import React from 'react';
import QuizQuestionTimer from './QuizQuestionTimer';
import CheckIndicator from '../CheckIndicator';
import { motion } from 'framer-motion';

export default function FillInTheBlankQuestion({ message, question, endedEarly, reportAnswer, isLocked, setIsLocked }) {
  const { Answers, Description } = question;
  const {
    timetoken,
    message: {
      data: { time },
    },
  } = message;

  const [answer, setAnswer] = React.useState('');
  const [successfulResponse, setSuccessfulResponse] = React.useState(false);
  const [placeHolder, setPlaceHolder] = React.useState('type your answer here');

  const onQuestionEnd = () => {
    setIsLocked(true);

    CrowdHub_App.INSTANCE.mServices.GetQuizQuestion(
      question.Id,
      function (aQuestionResponse) {},
      function () {},
    );
  };

  const onQuestionAlreadyEnded = () => {
    setIsLocked(true);
    setPlaceHolder('');
  };

  React.useEffect(() => {
    if (CrowdHub_App.INSTANCE.CurrentUser.IsLoggedIn() != true) {
      return;
    }
    setSuccessfulResponse(false);

    if (answer != '') {
      const timeOutForUpdate = setTimeout(() => {
        setSuccessfulResponse(true);
        CrowdHub_App.INSTANCE.mServices.SyncQuizAddResponse(
          question.Id,
          Answers[0]?.answer_id ? Answers[0].answer_id : {},
          answer,
          () => {},
          error => {
            setSuccessfulResponse(false);
          },
          true,
        );
      }, 750);

      return () => clearTimeout(timeOutForUpdate);
    }
  }, [answer]);

  return (
    <motion.div
      className={`question_question question_container question_message`}
      id={`${App.INSTANCE.CurrentUser.Id}${message.timetoken}`}
      variants={questionVariants}
      initial={'hidden'}
      animate={'show'}
    >
      <div className={`question ${isLocked ? 'locked' : ''}`}>
        <div className={`description`} dangerouslySetInnerHTML={{ __html: Description }} />
        <div className={`answers`}>
          <div className={`fillintheblank_indicator`}>
            <CheckIndicator isChecked={successfulResponse} />
          </div>
          <textarea
            value={answer}
            onChange={e => {
              if (!isLocked) {
                setAnswer(e.target.value);
              }
            }}
            spellCheck={true}
            autoComplete={`on`}
            placeholder={placeHolder}
            rows={3}
            cols={32}
            className={`default_input default_textarea scrolling_to_me`}
          />
        </div>
        <QuizQuestionTimer
          questionTime={timetoken}
          questionDuration={time}
          onQuestionEnd={onQuestionEnd}
          onQuestionAlreadyEnded={onQuestionAlreadyEnded}
          endedEarly={endedEarly}
        />
      </div>
    </motion.div>
  );
}

const questionVariants = {
  hidden: { opacity: 0, x: 50 },
  show: { opacity: 1, x: 0 },
};
